var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { PeekInputCheckbox, PeekStack } from "@piiqtechnologies/ui-components";
export const SpaceModelUnit = (_a) => {
    var { form, field, label } = _a, props = __rest(_a, ["form", "field", "label"]);
    const onChangeSpaceModelUnit = (isModelUnit) => {
        var _a;
        //@ts-ignore
        form.setFieldValue("isModelUnit", !((_a = isModelUnit === null || isModelUnit === void 0 ? void 0 : isModelUnit.target) === null || _a === void 0 ? void 0 : _a.value) || undefined);
    };
    return (React.createElement(PeekStack, { marginTop: 1.25, justifyContent: "center" },
        React.createElement(PeekInputCheckbox, Object.assign({ control: undefined, label: label, onChange: onChangeSpaceModelUnit, field: field }, props))));
};
export default SpaceModelUnit;
